import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export const DEFAULT_SHIFT_DISCOVERY_DATE_RANGE_WINDOW_IN_DAYS = 30;

export function useShiftDiscoveryDaysToFetch() {
  return useCbhFlag(CbhFeatureFlag.SHIFT_DISCOVERY_DAYS_TO_FETCH, {
    defaultValue: DEFAULT_SHIFT_DISCOVERY_DATE_RANGE_WINDOW_IN_DAYS,
  });
}
